import React from 'react'
import { ToolkitContentPage } from '../../components/ToolkitContentPage'
import toolkitContent from '../../data/toolkitContent.json'

export const ClinicsResourcesPage: React.FC = () => {
  // Find the Clinic Resources content from our JSON data
  const clinicContent = toolkitContent.find(
    (item) => item.title === 'Clinic Resources'
  )

  if (!clinicContent) {
    return (
      <div className="text-center py-12">
        <h1 className="text-2xl font-bold text-[#3C2416] mb-4">
          Page Not Found
        </h1>
        <p className="text-[#713d43]">
          The requested content could not be found.
        </p>
      </div>
    )
  }

  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Clinics', path: '/toolkit/clinics' },
    { label: 'Resources', path: '/toolkit/clinics/resources', isActive: true }
  ]

  return (
    <ToolkitContentPage
      title={clinicContent.title}
      htmlContent={clinicContent.html_content}
      breadcrumbs={breadcrumbs}
    />
  )
}
